<template>
  <div class="profile_wrapper most_profile driver_cards_container">
    <div class="container-fluid px-0" v-if="userInfo">
      <div class="row g-4">
        <div
          v-for="(card, index) in cardList"
          :key="index"
          class="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
        >
          <profile-card
            :link="card.link"
            :icon="card.icon"
            :title="card.title"
            :subTitle="card.subTitle"
            :color="card.color"
            :bgColor="card.bgColor"
            :gradient="card.gradient"
            :badge="card.badge"
          ></profile-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["userInfo"],

  data() {
    return {};
  },

  computed: {
    cardList() {
      if (!this.userInfo) return [];
      const id = this.userInfo.id;
      return [
        {
          link: `/driver/show/${id}/personalData`,
          icon: "fal fa-id-card",
          title: this.$t("users.personalData.title"),
          subTitle: "عرض وتعديل معلومات السائق الشخصية",
          color: "#6366f1",
          bgColor: "rgba(99, 102, 241, 0.1)",
          gradient: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        },
        {
          link: `/driver/show/${id}/vehicleData`,
          icon: "fal fa-car-alt",
          title: "بيانات المركبة",
          subTitle: "تفاصيل السيارة والرخصة والتأمين",
          color: "#0284c7",
          bgColor: "rgba(2, 132, 199, 0.1)",
          gradient: "linear-gradient(135deg, #0284c7 0%, #06b6d4 100%)",
        },
        {
          link: `/driver/show/${id}/deliveryOrders`,
          icon: "fal fa-shipping-fast",
          title: "التوصيلات",
          subTitle: "سجل رحلات وطلبات التوصيل",
          color: "#059669",
          bgColor: "rgba(5, 150, 105, 0.1)",
          gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
        },
        {
          link: `/driver/show/${id}/packageOrders`,
          icon: "fal fa-box-open",
          title: "الطرود",
          subTitle: "سجل واستلام طلبات الطرود",
          color: "#d97706",
          bgColor: "rgba(217, 119, 6, 0.1)",
          gradient: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
        },
        {
          link: `/driver/show/${id}/rates`,
          icon: "fal fa-star",
          title: "التقييمات",
          subTitle: "تقييمات آراء العملاء والملاحظات",
          color: "#ea580c",
          bgColor: "rgba(234, 88, 12, 0.1)",
          gradient: "linear-gradient(135deg, #ea580c 0%, #fbbf24 100%)",
        },
        {
          link: `/driver/show/${id}/orderStats`,
          icon: "fal fa-chart-pie",
          title: "إحصائيات الطلبات",
          subTitle: "رسوم وتفاصيل أداء الطلبات",
          color: "#7c3aed",
          bgColor: "rgba(124, 58, 237, 0.1)",
          gradient: "linear-gradient(135deg, #7c3aed 0%, #c026d3 100%)",
        },
        {
          link: `/driver/show/${id}/wallet`,
          icon: "fal fa-wallet",
          title: "المحفظة",
          subTitle: "الرصيد والمعاملات المالية",
          color: "#0d9488",
          bgColor: "rgba(13, 148, 136, 0.1)",
          gradient: "linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%)",
        },
        {
          link: `/driver/show/${id}/fines`,
          icon: "fal fa-exclamation-triangle",
          title: "مخالفات المندوبين",
          subTitle: "سجل المخالفات والغرامات المسجلة",
          color: "#dc2626",
          bgColor: "rgba(220, 38, 38, 0.1)",
          gradient: "linear-gradient(135deg, #dc2626 0%, #f87171 100%)",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.driver_cards_container {
  padding-top: 10px;
}
</style>
